import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/usageGuide/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/usageGuide/insert',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/usageGuide/update',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/usageGuide/batchDelete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/usageGuide.js